export default __webpack_public_path__ + "static/media/id_img.16e884c5.jpg";